import script from "./TressCarouselControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressCarouselControls.vue?vue&type=script&setup=true&lang=ts"

import "./TressCarouselControls.vue?vue&type=style&index=0&id=69d02895&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d02895"]])

export default __exports__